module.exports = __webpack_public_path__ + "img/nemotron-compression-ratio-comp.46da3fd6.png";